import { Component } from "@angular/core";
import { BaseComponent } from "./core/base";
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { AuthService, UserModel, UserService } from "@bt/core";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent extends BaseComponent {
  title = "app";


  async ngOnInit() {
    var t = this;
    this.router.events.subscribe((event: Event) => {

      // if (event instanceof NavigationStart) {
      //   t.setLoading(true);
        
      //   // let isCanContinue=false;
      //   // t.checkBaseData(t).then(x=>{
      //   //    t.setLoading(false);
      //   //    isCanContinue=true;
      //   // });
      //   // while(!isCanContinue){

      //   // }
      // }

      // if (event instanceof NavigationEnd) {
      //   t.setLoading(false);
      // }

      if (event instanceof NavigationError) {
        
        t.setLoading(false);
        t.userService.logout();
        console.log(event.error);
      }
    });
    //await t.checkBaseData(t);
  }

  public async checkBaseData(t: any, isCanLoad = false) {
    var listIsSendRequest = [];
    listIsSendRequest["getMeIsSend"] = false;
    function waiting(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
    try {
      while (!isCanLoad) {
        isCanLoad = true;
        if (!t.authService.isAuth()) {
          t.setLoading(false);
          return;
        }

        if (t.userService.getRole() == null) {
          if (!listIsSendRequest["getMeIsSend"]) {
            t.userService.getMe();
            listIsSendRequest["getMeIsSend"] = true;
          }

          isCanLoad = false;
        }
        // await waiting(800);
        let now = new Date().getTime();
        let millisecondsToWait = 2000; /* i.e. 1 second */
        while (new Date().getTime() < now + millisecondsToWait) { };
      };
    } catch (e) {
      console.log(e);
    }
  }

  constructor(private router: Router,
    private authService: AuthService,
    private userService: UserService) {
    super();
    this.setLoading(false);
    //прослушивает изменение innerhtml для этого контейнера
    window.onload = function () {
      (<any>window).$('notifier-container').bind("DOMSubtreeModified", function () {
        var all = document.getElementsByClassName('notifier__notification-button');
        for (var i = 0; i < all.length; i++) {
          (<any>all[i]).style.position = 'absolute';
          (<any>all[i]).style.right = '8px';
          (<any>all[i]).style.top = '-4px';
        }
        //(<any>window).$('notifier-container').unbind("DOMSubtreeModified");
      });



    };
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts